import { CommonModule, DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { CustomersService } from '../../../../core/services/customer/customers.service';
import { finalize } from 'rxjs';
import { CustomerListModel } from '../../../../core/models/customer/customer-list.model';
import { ToastService } from '../../../../core/services/toast.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-organization-list',
  standalone: true,
  imports: [CommonModule, DatePipe, RouterModule, FormsModule, TranslateModule],
  templateUrl: './organization-list.component.html',
  styleUrl: './organization-list.component.scss',
  providers: [DatePipe],
})
export class OrganizationListComponent {
  organizations: CustomerListModel[] = [];
  totalOrganization: number = 0;
  totalPage: number = 0;
  pageSize: number = 10;
  pageSizes = [10, 25, 50, 100];
  currentPage: number = 1;
  organizationListLoading: boolean = true;
  deleteModalId: string = '';
  filterForm = {
    name: '',
    customerCode: null,
    location: '',
    startCreatedDate: null as string | null,
    endCreatedDate: null as string | null,
    email: '',
    totalAnalysis: 0,
  };
  maxDate: string;
  customerCodes: any = [];

  constructor(
    private customersService: CustomersService,
    private datePipe: DatePipe,
    private toastService: ToastService,
    private translate: TranslateService
  ) {
    const today = new Date();
    this.maxDate = today.toISOString().split('T')[0];
  }

  ngOnInit(): void {
    this.getOrganizationList(this.currentPage, this.pageSize);
    this.getCustomerCodes();
  }

  filterOrganizationList(e: Event) {
    e.preventDefault();

    if (this.filterForm.startCreatedDate) {
      const transformedDate = new Date(this.filterForm.startCreatedDate);
      if (!isNaN(transformedDate.getTime())) {
        this.filterForm.startCreatedDate = this.datePipe.transform(
          transformedDate,
          'dd-MM-yyyy'
        );
      }
    }

    if (this.filterForm.endCreatedDate) {
      const transformedDate = new Date(this.filterForm.endCreatedDate);
      if (!isNaN(transformedDate.getTime())) {
        this.filterForm.endCreatedDate = this.datePipe.transform(
          transformedDate,
          'dd-MM-yyyy'
        );
      }
    }

    this.getOrganizationList(1, this.pageSize, this.filterForm);
  }
  getOrganizationList(page: number, size: number, filters?: any): void {
    this.organizationListLoading = true;
    this.customersService
      .customerList(page, size, filters)
      .pipe(
        finalize(() => {
          this.organizationListLoading = false;
        })
      )
      .subscribe({
        next: (res) => {
          this.organizations = res.items;
          this.totalOrganization = res.count;
          this.totalPage = res.pages;
          this.pageSize = res.size;
          this.currentPage = page;
        },
      });
  }
  getCustomerCodes() {
    this.customersService.allCustomerCodes().subscribe({
      next: (res) => {
        this.customerCodes = res;
      },
    });
  }

  clearFilters(): void {
    this.filterForm.name = '';
    this.filterForm.location = '';
    this.filterForm.startCreatedDate = null;
    this.filterForm.endCreatedDate = null;
    this.filterForm.email = '';
    this.filterForm.totalAnalysis = 0;
    this.getOrganizationList(this.currentPage, this.pageSize);
  }

  changePage(page: number): void {
    if (page > 0 && page <= this.totalPage) {
      this.getOrganizationList(page, this.pageSize, this.filterForm);
    }
  }

  changePageSize(event: Event): void {
    const selectElement = event.target as HTMLSelectElement;
    const size = Number(selectElement.value);
    this.pageSize = size;
    this.currentPage = 1;
    this.getOrganizationList(this.currentPage, this.pageSize, this.filterForm);
  }

  deleteOrganization(id: string): void {
    if (id) {
      this.customersService.deleteCustomer(id).subscribe({
        next: () => {
          this.toastService.showToast(
            this.translate.instant('organizationDeleted'),
            'success'
          );
          this.getOrganizationList(1, this.pageSize, this.filterForm);
        },
      });
    }
  }
}
